"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var abbreviateNumber_1 = __importDefault(require("../../utils/abbreviateNumber"));
var TileDataContext_1 = require("../TileDataContext");
function YMMTM() {
    var _a = (0, TileDataContext_1.useTileDataContext)().tileData, year = _a.year, make = _a.make, model = _a.model, trim = _a.trim, mileage = _a.mileage;
    return (react_1.default.createElement("div", { className: "flex flex-col justify-between" },
        react_1.default.createElement("p", { className: "truncate text-[18px] font-bold leading-[24px]", "data-qa": "make-model" },
            year,
            " ",
            make,
            " ",
            model),
        react_1.default.createElement("div", { className: "t-body-s flex items-center gap-4", "data-qa": "trim-mileage" },
            react_1.default.createElement("p", { className: "truncate" }, trim),
            react_1.default.createElement("span", { className: "shrink-0" }, "\u2022"),
            react_1.default.createElement("span", { className: "shrink-0" },
                (0, abbreviateNumber_1.default)(mileage),
                " miles"))));
}
exports.default = YMMTM;
//# sourceMappingURL=YMMTM.js.map